import { DashboardFilterSelectContainer, TimePickerContainer } from "./MoaDashboard.styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker, TimeView } from "@mui/x-date-pickers";
import { Divider } from "@mui/material";
import React, { Dispatch, FC, SetStateAction } from "react";
import { DashboardFilter } from "../../services/dashboard/dashboard.types";
import { Dayjs } from "dayjs";
import { debounce } from "lodash";

interface DashboardFilterSelectProps {
  filter: DashboardFilter
  setFrom: Dispatch<SetStateAction<Dayjs | undefined>>
  setUntil: Dispatch<SetStateAction<Dayjs | undefined>>
}

const DashboardFilterSelect: FC<DashboardFilterSelectProps> = (
    {
      filter,
      setFrom,
      setUntil
    }
) => {
  const muiTheme = createTheme();

  const setFromWithTimeout = debounce(setFrom, 1000);
  const setUntilWithTimeout = debounce(setUntil, 1000);

  //Restricts Minute Selection to only :00, :30, and :55
  const getShouldDisableTime = (value: Dayjs, view: TimeView) => {
    if (view === 'minutes') {
      return value.minute() % 30 !== 0 && value.minute() !== 55;
    }
    return false;
  }

  return (
      <DashboardFilterSelectContainer>
        <ThemeProvider theme={muiTheme} key={'time-picker-mui-theme'}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePickerContainer>
              <TimePicker
                  skipDisabled={true}
                  shouldDisableTime={getShouldDisableTime}
                  value={filter.from}
                  onChange={(newValue) => newValue && setFromWithTimeout(newValue)}
              />
            </TimePickerContainer>
            <Divider
                orientation="horizontal"
                variant={'middle'}
                flexItem
                sx={{ width: '16px', borderBottomWidth: '2px', backgroundColor: '#131313', alignSelf: 'center' }}
            />
            <TimePickerContainer>
              <TimePicker
                  skipDisabled={true}
                  shouldDisableTime={getShouldDisableTime}
                  value={filter.to?.minute() === 59 ? filter.to?.set('minutes', 55) : filter.to}
                  onChange={(newValue) => newValue && setUntilWithTimeout(newValue)}
              />
            </TimePickerContainer>
          </LocalizationProvider>
        </ThemeProvider>
      </DashboardFilterSelectContainer>
  )
}

export default DashboardFilterSelect;